import { motion } from "framer-motion";

export default function Method({ data }) {
  return (
    <section id="method" data-testid="method-section" className="py-24 lg:py-32 bg-alabaster">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-3xl">
          <p className="overline mb-6" data-testid="method-overline">{data.overline}</p>
          <h2
            data-testid="method-title"
            className="font-serif text-4xl sm:text-5xl lg:text-6xl font-light leading-tight text-onyx"
          >
            {data.title}
          </h2>
          <p data-testid="method-subtitle" className="mt-6 text-lg text-onyx/70 max-w-xl">
            {data.subtitle}
          </p>
        </div>

        <div className="mt-20 relative">
          {/* Vertical line */}
          <div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-px bg-border -translate-x-1/2" />
          <div className="space-y-16 md:space-y-24">
            {(data.phases || []).map((phase, i) => {
              const isLeft = i % 2 === 0;
              return (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-100px" }}
                  transition={{ duration: 0.7 }}
                  data-testid={`method-phase-${i}`}
                  className={`grid md:grid-cols-2 gap-8 md:gap-16 items-center ${
                    isLeft ? "" : "md:[direction:rtl]"
                  }`}
                >
                  <div className={`${isLeft ? "md:text-right" : "md:[direction:ltr] md:text-left"}`}>
                    <span className="font-serif text-[8rem] md:text-[10rem] leading-none font-extralight text-gold/40">
                      {phase.number}
                    </span>
                  </div>
                  <div className="md:[direction:ltr]">
                    <h3 className="font-serif text-3xl sm:text-4xl text-onyx leading-tight">
                      {phase.title}
                    </h3>
                    <p className="mt-4 text-base text-onyx/70 leading-relaxed">
                      {phase.description}
                    </p>
                    <div className="mt-6 inline-block border-l-2 border-gold pl-4">
                      <p className="text-xs tracking-[0.2em] uppercase text-onyx/50 mb-1">Objetivo</p>
                      <p className="text-sm font-semibold text-onyx">{phase.objective}</p>
                    </div>
                  </div>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
